/* istanbul ignore next */
/**
 * Dynamically import the @aws-amplify libraries needed for federated login.
 */
export async function loadAmplify() {
    const { Hub, Auth } = await import('./amplify');
    return { Hub, Auth };
}
